import values from 'lodash/values'
import { createSelector } from 'reselect'

import { makeExtendedFilterRugs, makeFilterRugs, makeSortRugs } from 'Global/Helpers/rugHelpers'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'

const _page = state => state.layout.search.page

export const dones = state => state.search.dones
export const errors = state => state.search.errors
export const extendedFilters = state => state.search.extendedFilters
export const filters = state => state.search.filters
export const layout = state => state.layout.search.layout
export const limit = state => state.layout.search.limit
export const pendings = state => state.search.pendings
export const previewOpen = state => state.previewModal.search.visible
export const rugs = state => state.rugs.data
export const rugsDone = state => state.rugs.done
export const rugsError = state => state.rugs.error
export const rugsPending = state => state.rugs.pending
export const searchForm = state => state.search.searchForm
export const sortBy = state => state.layout.search.sortBy
export const sortOrder = state => state.layout.search.sortOrder
export const user = state => state.auth.user

/**
 * Iterates over all rugs and filters out all rugs which don't meet at least
 * one of the filter criteria.
 */
export const filterRugs = createSelector(
  [filters, extendedFilters, sortBy, sortOrder, rugs, _userPermissions],
  (filters, extendedFilters, sortBy, sortOrder, rugs, userPermissions) => {
    const filter = makeFilterRugs(filters, userPermissions)
    const extendedFilter = makeExtendedFilterRugs(extendedFilters)
    const sort = makeSortRugs(sortBy, sortOrder)

    return values(rugs)
      .filter(filter)
      .filter(extendedFilter)
      .sort(sort)
  },
)

/**
 * Takes the filtered rugs and slices the array to the set limit per page.
 */
export const slicedFilteredRugs = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return filteredRugs.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

/**
 * Creates a pagination object with current page, total pages, total rugs
 */
export const calculatePagination = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return {
      page,
      pages: Math.ceil(filteredRugs.length / limit),
      totalRugs: filteredRugs.length,
    }
  },
)
